import React, { createContext, useState, useEffect } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false); // ✅ New flag

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem('cart')) || [];
    setCartItems(stored);
    setIsInitialized(true); // ✅ Cart has loaded from storage
  }, []);

  useEffect(() => {
    if (isInitialized) {
      localStorage.setItem('cart', JSON.stringify(cartItems));
    }
  }, [cartItems, isInitialized]);

  const toggleCart = () => setShowCart((prev) => !prev);

  const addToCart = (item) => {
    setCartItems((prev) => {
      const existing = prev.find(
        (p) => p.name === item.name && p.size === item.size
      );
      if (existing) {
        return prev.map((p) =>
          p.name === item.name && p.size === item.size
            ? { ...p, quantity: p.quantity + item.quantity }
            : p
        );
      } else {
        return [...prev, item];
      }
    });
  };

  const removeFromCart = (index) => {
    setCartItems((prev) => {
      const updated = [...prev];
      updated.splice(index, 1);
      return updated;
    });
  };

  const updateCartItem = (index, newItem) => {
    setCartItems((prev) => {
      const updated = [...prev];
      updated[index] = newItem;
      return updated;
    });
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        updateCartItem,
        showCart,
        toggleCart,
        isInitialized // Pass this down if needed
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
